(() => {
  const CACHE = new Map(); // key: url -> html

  function getSectionUrl(btn) {
    try {
      const productUrl = (btn.getAttribute('data-product-url') || '').split('?')[0];
      if (!productUrl) return null;
      return productUrl + (productUrl.includes('?') ? '&' : '?') + 'section_id=quick-add';
    } catch (e) { return null; }
  }

  function prefetch(btn){
    const url = getSectionUrl(btn);
    if (!url || CACHE.has(url)) return;
    fetch(url, { credentials: 'same-origin', cache: 'force-cache' })
      .then(r => r.ok ? r.text() : '')
      .then(html => { if (html) CACHE.set(url, html); })
      .catch(() => {});
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) prefetch(entry.target); });
  }, { rootMargin: '300px' }) : null;

  function bindButton(btn){
    if (observer) observer.observe(btn);
    btn.addEventListener('mouseenter', () => prefetch(btn), { passive: true });
    btn.addEventListener('touchstart', () => prefetch(btn), { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.quick-add__submit[aria-haspopup="dialog"][data-product-url]').forEach(bindButton);
  });

  // If prefetched, inject immediately into the modal content container
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quick-add__submit[aria-haspopup="dialog"][data-product-url]');
    if (!btn) return;
    const url = getSectionUrl(btn);
    const html = url && CACHE.get(url);
    if (!html) return;

    // Find the destination container by product id from the url if possible
    const m = (btn.getAttribute('data-product-url') || '').match(/\/(?:products|collections)\/[^?]+/);
    const idGuess = (btn.id || '').replace(/[^0-9]/g, '');
    const info = idGuess ? document.getElementById('QuickAddInfo-' + idGuess) : null;
    if (info && !info.innerHTML.trim()) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const bodyHTML = doc.body ? doc.body.innerHTML : html;
      info.innerHTML = bodyHTML;
    }
  }, true);
})();




